import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { supabase } from '../services/supabaseClient';

// Login de coaches con magic link de Supabase. shouldCreateUser:false => sólo se
// envía enlace a emails ya provisionados (= coaches). El acceso final lo valida
// además el CoachProvider/guard (debe existir un coach activo con ese email).
export default function Login() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | sending | sent | error
  const [message, setMessage] = useState(
    searchParams.get('error') === 'not_authorized'
      ? 'Tu cuenta no tiene un coach activo asociado. Contacta con el administrador.'
      : ''
  );

  // Si ya hay sesión, ir directo al dashboard.
  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      if (data?.session) navigate('/dashboard', { replace: true });
    });
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    setMessage('');
    const { error } = await supabase.auth.signInWithOtp({
      email: email.trim(),
      options: {
        shouldCreateUser: false,
        emailRedirectTo: `${window.location.origin}/dashboard`,
      },
    });
    if (error) {
      setStatus('error');
      setMessage(
        'No pudimos enviar el enlace. Verifica que el email pertenece a un coach registrado.'
      );
      return;
    }
    setStatus('sent');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md bg-white rounded-lg shadow p-8">
        <h1 className="text-2xl font-semibold text-gray-900 mb-2">Incredibilis Fitness</h1>
        <p className="text-sm text-gray-500 mb-6">
          Acceso de entrenadores. Te enviaremos un enlace de acceso a tu email.
        </p>

        {status === 'sent' ? (
          <div className="rounded-md bg-green-50 p-4 text-sm text-green-800">
            Revisa tu email: te hemos enviado un enlace de acceso a{' '}
            <strong>{email}</strong>.
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                Email
              </label>
              <input
                id="email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-gray-900 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                placeholder="tucorreo@ejemplo.com"
              />
            </div>
            {message && <p className="text-sm text-red-600">{message}</p>}
            <button
              type="submit"
              disabled={status === 'sending'}
              className="w-full inline-flex justify-center rounded-md bg-indigo-600 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-700 disabled:opacity-50"
            >
              {status === 'sending' ? 'Enviando…' : 'Enviar enlace de acceso'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
